import React, {useContext, useState} from "react";
import "../styles/styles.css"
import Error from "./Error";
import EnvCtx from "../contexts/EnvCtx";
import { useTranslation } from 'react-i18next'
import CameraCntx from "../contexts/CameraCntx";

const SezioneC = () => {
    const { cciaa } = useContext(EnvCtx);
    const { t } = useTranslation();
    let chiaveSezione = "C";
    const [isOpen, setIsOpen] = useState(true);
    const {selectedMediazione, sezioneC, selectedLiteA, selectedLiteB, selectedTipoSpesaB, tipiSpesaC, selectedTipoSpesaC, setSelectedTipoSpesaC, totaleB, totaleC,
        setTotaleC, error, showErrorC, calculTotalC, handleErrorClick, formatNumber, getDescrizioneByLingua, getSottoTitoloByLingua, getTestoSezioneByLingua} = useContext(CameraCntx);

    if (!sezioneC) return null;

    const sottoTitolo = getSottoTitoloByLingua(sezioneC)?.trim();

    const testo = getTestoSezioneByLingua(sezioneC)?.trim();

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    const handleTipoSpesaCChange = (event) => {
        setSelectedTipoSpesaC(tipiSpesaC.find(item => item.chiave === event.target.value));
        const newTotaleC = calculTotalC(event.target.value, totaleB);
        setTotaleC(newTotaleC);
    };

    return (
        <div className="accordion sezione-accordion" id="accordionSezionC" style={{backgroundColor: cciaa ? cciaa.background_colore : ""}}>
            <div className="accordion-item">
                <h2 className="accordion-header">
                    <button
                        className={`accordion-button ${isOpen ? '' : 'collapsed'} sezione-accordion-button`}
                        type="button"
                        onClick={toggleAccordion}
                        aria-expanded={isOpen ? "true" : "false"}
                        aria-controls="panelcollapseSezioneC"
                        style={{backgroundColor: cciaa ? cciaa.background_colore : ""}}
                    >
                        <span>{sezioneC.chiave}. {getDescrizioneByLingua(sezioneC)}</span>
                    </button>
                </h2>
                <div
                    id="panelcollapseSezioneC" className={`accordion-collapse ${isOpen ? 'show' : ''}`}>
                    <div className={`accordion-body sezione-accordion-body`}>
                        {testo ? (
                            <div >
                                <p className="sezione-p"> {testo}</p>
                            </div>
                        ) : null}

                        <div className="col-8">
                            <div className="row">
                                <div className="col-6"></div>
                                <div className="col-6"> {error && showErrorC && <Error errors={[error]} />}</div>
                            </div>
                        </div>
                        <div className="row mb-1">
                            {tipiSpesaC.length > 0 && tipiSpesaC.map((item) => (
                                <div className="col-md-6 mb-1 sezione-div-error" key={item.id}>
                                    <div className={`invisible_div ${(!selectedMediazione || ! selectedLiteA || !selectedLiteB || !selectedTipoSpesaB) ? 'radioinput-error-cal' : ''} mt-1 me-2 mb-1`} onClick={() => handleErrorClick(chiaveSezione)}></div>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            id={`tipoSpesa_${item.id}`}
                                            name="spesac_radio"
                                            value={item.chiave}
                                            onChange={handleTipoSpesaCChange}
                                            checked={selectedTipoSpesaC && selectedTipoSpesaC.chiave === item.chiave}
                                            disabled={!selectedMediazione || !selectedLiteB || !selectedTipoSpesaB }
                                        />
                                        <label className="form-check-label" htmlFor={`tipoSpesa_${item.id}`}>{getDescrizioneByLingua(item)}</label>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="row mb-1">
                            <div className="col-md-9">
                                <p className="sezione-total">{t("sezioneC.totale")}</p>
                            </div>
                            {selectedTipoSpesaC && totaleC > 0 &&(
                                <div className="col-md-3 d-flex align-items-center justify-content-right">
                                    <span className="badge rounded-pill text-bg-light sezione-total">€ {formatNumber(totaleC)}</span>
                                </div>
                            )}
                        </div>

                        {sottoTitolo ? (
                            <div className="font-italic mt-2">
                                <p className="sezione-p"> {sottoTitolo}</p>
                            </div>
                        ) : null}

                    </div>
                </div>
            </div>
        </div>
    );
};

export default SezioneC;
